import { fetchProfile, patchProfile } from './profileApi';
import {
  extractMedicalQuestionnaireCompleted,
  resolveProfileRecord,
} from '../utils/profileDisplaySummary';

/** Reads `medical_questionnaire_completed` from `GET /profile`. */
export async function fetchMedicalQuestionnaireCompleted(): Promise<boolean> {
  const data = await fetchProfile();
  return extractMedicalQuestionnaireCompleted(resolveProfileRecord(data));
}

/** Marks the gym health questionnaire complete via `PATCH /profile`. */
export async function markMedicalQuestionnaireCompleted(): Promise<void> {
  await patchProfile({ medical_questionnaire_completed: true });
}
